import { PieChart as ReactPieChart } from 'react-minimal-pie-chart';

type Slice = {
    color: string;
    percent: number;
    title: string;
    count: number;
    legend: string;
};

type PieChartProps = {
    slices: Slice[];
};

function PieChart({ slices }: PieChartProps): JSX.Element {
    const noActiveWorkpapers = slices.every((slice) => slice.count === 0);
    const fullCircle = slices.some((slice) => slice.percent === 100);

    return (
        <div className="relative">
            <div className="h-[200px] w-[200px] text-gray-600 dark:text-white mx-auto">
                <ReactPieChart
                    animate={!noActiveWorkpapers}
                    lineWidth={25}
                    startAngle={270}
                    data={
                        noActiveWorkpapers
                            ? [{ color: '#E5E7EB', value: 100, title: '0 open workpapers' }]
                            : slices.map((slice) => {
                                  return { color: slice.color, value: slice.percent, title: slice.title };
                              })
                    }
                    labelPosition={0}
                    label={noActiveWorkpapers ? (): string => '0%' : fullCircle ? (): string => '100%' : undefined}
                    labelStyle={{ fill: 'currentColor', fontSize: '1rem', lineHeight: '1.25rem' }}
                    paddingAngle={fullCircle || noActiveWorkpapers ? undefined : 1}
                />
            </div>
            <div className="flex flex-col gap-y-2 absolute right-0 top-0">
                {slices.map((slice) => {
                    return (
                        <div key={slice.title} className="flex gap-x-1 items-center">
                            <span className="w-3.5 h-3.5 rounded-full" style={{ backgroundColor: slice.color }}></span>
                            <label className="text-sm font-bold text-gray-600 dark:text-gray-400">{slice.legend}</label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
export default PieChart;
